import classNames from "classnames";
import { twMerge } from "tailwind-merge";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
}

export default function ToolbarButton({ isActive, className, ...props }: Props) {
  return (
    <button
      {...props}
      aria-checked={isActive}
      className={twMerge(
        classNames(
          "flex h-7 w-7 items-center justify-center rounded-md border border-transparent transition-colors duration-200 ease-in-out aria-checked:border-purple-300 aria-checked:shadow-sm",
          {
            "bg-purple-100 text-purple-600 hover:bg-purple-200": isActive,
            "bg-gray-100 hover:bg-purple-100 hover:text-purple-600": !isActive,
          },
        ),
        className,
      )}
    />
  );
}

export function ToolbarButtonGroup({
  children,
  className,
  ...props
}: React.HTMLProps<HTMLDivElement>) {
  return (
    <div className={twMerge("group flex rounded-md bg-gray-100", className)} {...props}>
      {children}
    </div>
  );
}
